module.exports = __webpack_public_path__ + "img/service_icon.bdee490e.png";